import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface BlueVizaConversion {
  blueviza_deal_id: string;
  blueviza_deal_name: string;
  blueviza_closed_date: string;
  blueviza_amount: number;
  divus_deal_id: string;
  divus_deal_name: string;
  divus_closed_date: string;
  divus_amount: number;
  dias_para_conversao: number;
  cliente: string;
}

export function useBlueVizaConversions() {
  return useQuery({
    queryKey: ['blueviza-conversions'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('v_blueviza_conversions')
        .select('*')
        .order('divus_closed_date', { ascending: false });

      if (error) throw error;
      return data as BlueVizaConversion[];
    },
  });
}
